import { render } from "./loadingEffect.vue?vue&type=template&id=0eafe698&scoped=true"
const script = {}

import "./loadingEffect.vue?vue&type=style&index=0&id=0eafe698&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eafe698"]])

export default __exports__